import { Card } from '@chakra-ui/react';
import { QuoteRevenueByYear } from '@monetize/types/app';
import {
  formatCurrency,
  formatCurrencyDelta,
  toDateShort,
} from '@monetize/utils/core';
import { FC } from 'react';
import { MCard, MDivider, MFlex, MGrid, MText } from '../../Monetize';

interface QuoteAnnualBreakdownAnalyticsCardProps {
  data: QuoteRevenueByYear;
  currency: string;
  yearLabel: number;
}

// Value columns grow to fit the widest amount so every row stays aligned
const VALUE_COLUMN = 'minmax(110px, max-content)';
const GRID_COLUMNS = `minmax(0, 1fr) ${VALUE_COLUMN} ${VALUE_COLUMN}`;

export const QuoteAnnualBreakdownAnalyticsCard: FC<
  QuoteAnnualBreakdownAnalyticsCardProps
> = ({ data, currency, yearLabel }) => {
  const { end, start, revenue } = data;

  return (
    <MCard variant="borderless" mt="2">
      <Card.Body>
        <MFlex flexDirection="column">
          <MFlex justifyContent="space-between" alignItems="center">
            <MText fontSize="xl">{`Year ${yearLabel}`}</MText>
            <MText fontSize="sm">
              {!!start && !!end
                ? `${toDateShort(start)} to ${toDateShort(end)}`
                : ''}
            </MText>
          </MFlex>
          <MDivider my="2" />
          <MGrid
            templateColumns={GRID_COLUMNS}
            columnGap={4}
            alignItems="center"
          >
            <MText
              gridColumn={2}
              textAlign="right"
              fontSize="xs"
              fontWeight={600}
              color="tGray.darkPurple"
            >
              TOTAL
            </MText>
            <MText
              textAlign="right"
              fontSize="xs"
              fontWeight={600}
              color="tGray.darkPurple"
            >
              INCREMENTAL
            </MText>
            <MText fontSize="md" fontWeight={600}>
              ARR
            </MText>
            <MText
              textAlign="right"
              whiteSpace="nowrap"
              fontSize="md"
              fontWeight={600}
            >
              {formatCurrency(revenue.current.arr, { currency })}
            </MText>
            <MText
              textAlign="right"
              whiteSpace="nowrap"
              fontSize="md"
              fontWeight={600}
            >
              {formatCurrencyDelta(revenue.delta.arr, { currency })}
            </MText>
            <MText fontSize="md" fontWeight={600}>
              MRR
            </MText>
            <MText
              textAlign="right"
              whiteSpace="nowrap"
              fontSize="md"
              fontWeight={600}
            >
              {formatCurrency(revenue.current.mrr, { currency })}
            </MText>
            <MText
              textAlign="right"
              whiteSpace="nowrap"
              fontSize="md"
              fontWeight={600}
            >
              {formatCurrencyDelta(revenue.delta.mrr, { currency })}
            </MText>
          </MGrid>
        </MFlex>
      </Card.Body>
    </MCard>
  );
};
